import PropTypes from 'prop-types';
import React from 'react';

import Select from 'react-select'
import {Field} from 'redux-form'


const renderField = ({label, input, fieldId, disabled, options, placeholder, isOptional, forceValidation, hint, isSearchable, meta: {touched, active, error, warning}}) => {

    return (
        <div className={((touched || (forceValidation && error)) ? (error ? 'labeled-select--error ' : 'labeled-select--valid ') : '') + (active ? 'labeled-select--focus ' : '') + 'labeled-select'}>
            <label htmlFor={fieldId}>{label} {isOptional ? <span>{"(optional)"}</span> : ''}</label>
            <Select
                disabled={disabled}
                name={fieldId}
                options={options}
                placeholder={placeholder}
                searchPromptText="Wählen Sie aus..."
                loadingPlaceholder=""
                noResultsText=""
                searchable={isSearchable}
                inputProps={{autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off'}}
                value={input.value}
                onFocus={input.onFocus}
                autoFocus={false}
                clearable={false}
                scrollMenuIntoView={false}
                onChange={(e) => {
                    if (e) {
                        input.onChange(e.value)
                    } else {
                        input.onChange(null)
                    }
                }}
                onBlur={() => input.onBlur(input.value)}
                autosize={false}
            />
            {(hint || (touched && error)) && <div className="hint">{((touched || (forceValidation && error)) && error) ? error : hint}</div>}
        </div>
    )
}

function LabeledSelect(props) {

    return <Field name={props.fieldId} forceValidation={props.forceValidation} component={renderField} props={props}/>;

}

LabeledSelect.propTypes = {
    options: PropTypes.array.isRequired,
    fieldId: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    isOptional: PropTypes.bool,
    isSearchable: PropTypes.bool.isRequired,
    forceValidation: PropTypes.bool,
    hint: PropTypes.string
};

LabeledSelect.defaultProps = {
    placeholder: "",
    forceValidation: false
};

export default LabeledSelect



/** WEBPACK FOOTER **
 ** ./src/components/forms/LabeledSelect.js
 **/